import React from 'react';

const FolderSystemGenerated = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="#EF4923" />
    <path
      d="M15.0998 9.15527H8.37253C7.90162 9.15527 7.49798 9.42436 7.29617 9.86163L5.24436 13.4607C4.94164 14.2343 5.47982 15.0753 6.32072 15.0753H13.048C13.5189 15.0753 13.9225 14.8062 14.1243 14.3689L16.1761 10.7698C16.4789 9.99618 15.9407 9.15527 15.0998 9.15527Z"
      fill="white"
    />
    <path
      d="M6.3209 8.85203C6.55635 8.34749 7.0609 8.01112 7.63272 8.01112H13.9563C14.1918 8.01112 14.2927 7.7084 14.1581 7.54022L10.5254 4.37841C9.95362 3.87386 9.0118 3.87386 8.40635 4.37841L4.43727 7.87658C4.16818 8.11203 4 8.41476 4 8.68385V12.0138C4 12.2829 4.37 12.3838 4.50454 12.1147L6.3209 8.81839V8.85203Z"
      fill="white"
    />
  </svg>
);

export default FolderSystemGenerated;
